import React from "react";

interface Props {
	children: React.ReactNode;
	className?: string;
	dataTestId?: string;
}

const StickyFooter = ({ children, className, dataTestId }: Props) => {
	return (
		<footer className={`sticky-footer ${className ?? ""}`} data-testid={dataTestId}>
			<div className="sticky-footer-container">{children}</div>
		</footer>
	);
};

export default StickyFooter;
